<template>

	<div>
		{{ item }}

		<div class="row top">
			<div class="col-sm-6">

				<b-form-group
					label-size="sm"
					label-for="refName"
					class="required"
				>
					<label class="lebeltop">{{$t('pos.sum')}} </label>

					<b-form-input style="width: 100%"
								  size="sm"
								  type="text"
								  autocomplete="off"
								  id="firstName"
								  v-model="amount"
								  ref="percentageRef"
								  v-on:keyup="amountChanged"
					/>
				</b-form-group>
			</div>
			<div class="col-sm-6">
				<b-form-group
					label-size="sm"
					class="required"
					label-for="lastName">
					<label class="lebeltop">{{$t('pos.sum')}} (-)</label>
					<b-form-input size="sm"
								  type="text"
								  autocomplete="off"
								  id="lastName"
								  v-model="totalAmount"
								  :disabled="1===1"
								  ref="fixedRef"
					/>
				</b-form-group>
			</div>

		</div>
		<div class="row top mt-3 justify-content-end">
			<div class="col-4">
				<b-button variant="outline-danger" size="sm" block
						  @click="closeModal">
					{{$t('actions.cancel')}}
				</b-button>
			</div>
			<div class="col-4">
				<b-button variant="outline-success" size="sm" block @click="saveSubmit">
					{{$t('actions.save')}}
				</b-button>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: "Payment",
		props: {
			item: {
				type: Object,
				default: false
			},
			amount:0,
			totalAmount:0,
		},
		data() {
			return {
			}
		},
		methods: {
			closeModal() {
				this.$emit("close", false);
			},
			amountChanged($event){
			},

			async saveSubmit() {

			},


		},
		computed: {

		}
	}

</script>

<style scoped>

</style>
